
window.addEventListener('load', function() {
 const allTitles = document.querySelectorAll('.card-information .card-information__wrapper a');
  allTitles?.forEach((title) => {
      let text = title.innerText;
      const textArr = text.split(' ');
      if (text.includes('pcs/Case') && text.length < 30) {
          const lastElement = textArr.pop();
          title.innerHTML = textArr.join(' ') + '<br />' + lastElement;
      }
  });
})
